import { Client } from "@/Common/Api/Client";
import { DateTime } from "@/Common/Helpers/DateTime";
import { MyleDSQMedication } from "@/Common/Models/DSQ/MyleDSQMedication";
import { MyleDSQMedicationItem } from "@/Common/Models/DSQ/MyleDSQMedicationItem";
import { Server } from "@/Common/Operations/operations.server";
import { toLookupDictionary } from "@/Common/Utilities/Collections/ArrayUtility";
import { MedicalItemMedicationAndPrescription } from "@/Patient/Models/MedicalSummary/MedicalItemMedicationAndPrescription";

class DsqMedicationsTools {
    public static InitDSQMedicationitems(dsqMedicationItems: MyleDSQMedicationItem[], patientContactId: string, isFullActiveMedsListRequest: boolean): MyleDSQMedication[] {
        if (!dsqMedicationItems?.any())
            return [];

        let dsqMedications = dsqMedicationItems.map(p => new MyleDSQMedication(p));
        if (!isFullActiveMedsListRequest)
            return dsqMedications;

        let dsqMedicationsByDsqId = toLookupDictionary(dsqMedications.filter(p => p.Model.DSQMedicationID != null), p => p.Model.DSQMedicationID);

        let medsToUpdate: MedicalItemMedicationAndPrescription[] = []; // Send to Server After to refresh with DSQ Latest Info (Already imported meds)
        let medsModels = patientStore.PatientMedicalSummaryModels[patientContactId].get("MedicalItemsMedicationAndPrescription");
        medsModels
            .filter(p => p.Model.DsqId != null)
            .forEach(med => {
                med.Model.DSQNumberOfRefillRemaining = 0;

                let matchingDsqMed = dsqMedicationsByDsqId.get(med.Model.DsqId)?.firstOrDefault();
                if (matchingDsqMed != null) {
                    if (!matchingDsqMed.Model.IsPendingMedication)
                        med.Model.DSQNumberOfRefillRemaining = matchingDsqMed.Model.RefillsRemaining;

                    med.Model.LastDSQPickupDate = new Date(matchingDsqMed.Model.LastPickupDate);
                    med.Model.LastDSQSyncDate = DateTime.nowMoment().toDate();
                    medsToUpdate.push(med.Model);

                    matchingDsqMed.MyleMedicationId = med.Model.Id;
                    matchingDsqMed.IsAlreadyInMyle = true;
                    matchingDsqMed.IsSelected = !matchingDsqMed.IsAlreadyInMyle;
                }
            });

        if (!dsqMedications.some(x => x.Model.IsPendingMedication)) {
            // Update Client with DSQ Refill Info
            patientStore.PatientMedicalSummaryModels[patientContactId] =
                patientStore.PatientMedicalSummaryModels[patientContactId]
                    .set("MedicalItemsMedicationAndPrescription", medsModels);

            // update Server with DSQ Refill Info
            const client = new Client();
            client.PostDSQ(
                Server.Myle_UpdateMedicationDSQInfo,
                {
                    PatientContactId: patientContactId,
                    DSQInfos: medsToUpdate
                },
                () => { }
            );
        }

        return dsqMedications;
    }
}

export { DsqMedicationsTools };
